import styled from "styled-components"

export const Container = styled.div`
   background-color: var(--medGrey);
   display: flex;
`

export const Wrapper = styled.div`
   flex: 1;
`

export const Main = styled.div`
   margin-top: 10px;
   flex: 4;
   color: var(--lightGrey);
   padding: 20px;
`

export const TitleWrapper = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
`

export const Title = styled.h1``

export const WideBox = styled.div`
   margin-bottom: 20px;
   padding: 20px;
   -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
   box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
   background-color: var(--darkGrey);
   border-radius: 10px;
`

export const StyledForm = styled.form``

export const FormItem = styled.div`
   width: 400px;
   display: flex;
   flex-direction: column;
   justify-content: center;
   margin-bottom: 15px;
   margin-right: 20px;
`

export const StyledSelect = styled.select`
   width: 400px;
   color-scheme: dark;
   height: 30px;
   border-radius: 5px;
`

export const StyledOption = styled.option``

export const StyledLabel = styled.label`
   margin: 5px 0px;
`

export const StyledInput = styled.input`
   background-color: var(--darkGrey);
   color: var(--lightGrey);
   border: none;
   border-bottom: 1px solid var(--primary);
   height: 30px;

   :focus {
      border-bottom: 1px solid var(--secondary);
      outline: none;
   }
`

export const StyledTextArea = styled.textarea`
   width: 400px;
   background-color: var(--darkGrey);
   color: var(--lightGrey);
   border: 1px solid var(--primary);
   height: 100px;

   :focus {
      border: 1px solid var(--secondary);
      outline: none;
   }
`

export const ButtonContainer = styled.div`
   width: 100%;
   display: flex;
   justify-content: center;
`

export const ButtonWrapper = styled.div`
   margin-bottom: 20px;
   padding: 20px;
   border-radius: 10px;
   -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
   box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
   background-color: var(--darkGrey);
   color: var(--lightGrey);
   width: 300px;
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;
`

export const Message = styled.div`
   margin-top: 20px;
   color: var(--secondary);
`

export const StyledButton = styled.button`
   width: 80px;
   border: none;
   padding: 5px;
   background-color: var(--primary);
   border-radius: 5px;
   color: var(--white);
   font-size: var(--fontM);
   cursor: pointer;
`

export const GeneralInfo = styled.div`
   display: flex;
   flex-wrap: wrap;
`
